"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UniV2LikeRouterContract = void 0;
const ethers_1 = require("ethers");
const abi_1 = require("../../abi/abi");
const address_1 = require("../../utils/address");
class UniV2LikeRouterContract {
    constructor(address) {
        if (!(0, address_1.validateContractAddress)(address)) {
            throw new Error('Invalid address for LP router contract');
        }
        this.contract = new ethers_1.Contract(address, abi_1.abi.liquidity.uniV2LikeRouter);
    }
    createAddLiquidity(tokenA, tokenB, amountADesired, amountBDesired, amountAMin, amountBMin, to, deadline) {
        return this.contract.addLiquidity.populateTransaction(tokenA, tokenB, amountADesired, amountBDesired, amountAMin, amountBMin, to, deadline);
    }
    createRemoveLiquidity(tokenA, tokenB, liquidity, amountAMin, amountBMin, to, deadline) {
        return this.contract.removeLiquidity.populateTransaction(tokenA, tokenB, liquidity, amountAMin, amountBMin, to, deadline);
    }
}
exports.UniV2LikeRouterContract = UniV2LikeRouterContract;
